// Platform support-ticket operator queue (ai-agent-service via the gateway).
import axios from 'axios';

const API_V1 = (import.meta.env.VITE_API_URL || 'http://localhost:8000/api/v1').replace(
  /\/api(\/v1)?\/?$/,
  '/api/v1',
);

export interface SupportTicket {
  id: string;
  ref: string;
  tenant_id: string;
  reporter_email?: string | null;
  reporter_name?: string | null;
  module?: string | null;
  category?: string | null;
  priority: string;
  status: string;
  subject?: string | null;
  summary?: string | null;
  assigned_to?: string | null;
  assignee_email?: string | null;
  assignee_name?: string | null;
  sla_due_at?: string | null;
  first_response_at?: string | null;
  resolved_at?: string | null;
  created_at?: string;
}

export interface TicketNote {
  id: string;
  author_id?: string | null;
  author_email?: string | null;
  body: string;
  created_at: string;
}

export interface TicketPatch {
  status?: string;
  priority?: string;
  assignee_id?: string;
  assignee_email?: string;
  assignee_name?: string;
}

const BASE = `${API_V1}/support/platform`;

export const listSupportTickets = (params: {
  status?: string;
  priority?: string;
  assignee?: string;
  tenant?: string;
  q?: string;
  limit?: number;
}) => axios.get<{ tickets: SupportTicket[] }>(`${BASE}/tickets`, { params }).then((r) => r.data.tickets || []);

export const getSupportTicket = (id: string) =>
  axios.get<SupportTicket & { notes: TicketNote[] }>(`${BASE}/tickets/${id}`).then((r) => r.data);

export const updateSupportTicket = (id: string, patch: TicketPatch) =>
  axios.patch<SupportTicket>(`${BASE}/tickets/${id}`, patch).then((r) => r.data);

export const addSupportNote = (id: string, body: string) =>
  axios.post<TicketNote>(`${BASE}/tickets/${id}/notes`, { body }).then((r) => r.data);
